export const CONTEXT_CHANGED_EVENT = 'contextChanged'

export const emitContextChanged = (source: string) => {
  if (typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(
    new CustomEvent(CONTEXT_CHANGED_EVENT, {
      detail: { source, at: Date.now() },
    })
  )
}
